import React from 'react'
import injectSheet from 'react-jss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCrown } from '@fortawesome/pro-solid-svg-icons/faCrown'
import ButtonElement from 'pobble-components/dist/button-element'
import { useState } from 'react'
import { useEffect } from 'react'
import { apiClient } from 'pobble-components/dist/api'
import { Image } from 'pobble-components/dist/image'
import { useHistory, useRouteMatch } from 'react-router-dom'
import { useMemo } from 'react'
import { errorHandler } from 'pobble-components/dist/error-handler'
import Spinner from 'pobble-components/dist/spinner'
import { useSubscriptionDetails } from 'pobble-components/dist/subscriptions/utils'
import { PromptsLayout } from '../../../prompts-layout'

const keywords = [
  'chocolate',
  'fairy tale',
  'stone age',
  'community',
  'vikings',
  'titanic',
  'inventions',
  'superheroes',
  'greeks',
  'volcanoes',
  'environment',
  'tree of life',
  'london',
  'antarctica',
  'inspirational people',
  'astronaut',
  'food health',
  'deep blue',
  'explorers',
  'my life as a window',
  'water',
  'beasts of the past',
  'rainforest',
  'fantasy',
  'world war',
  'poetry',
  'humans:',
  'earthquakes'
]

export const Topics = injectSheet({
  container: {
    background: '#191919',
    color: '#fff',
    minHeight: '100vh',
    padding: '0 0 120px'
  },
  topBox: {
    color: 'var(--gray)',
    background: '#191919',
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    marginLeft: 'auto',
    padding: '32px 24px 8px',
    position: 'sticky',
    top: '0',
    zIndex: '50',
    '& p': {
      font: 'var(--body)',
      margin: '0 0 24px',
      color: 'var(--light-gray--)',
      padding: '0 24px'
    }
  },
  main: {
    padding: '0 24px'
  },
  yearGroupSelection: {
    textAlign: 'center',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    '& ul': {
      listStyle: 'none',
      padding: '4px 4px 16px',
      margin: '-4px',
      font: 'var(--body)',
      display: 'flex',
      gap: '16px',
      overflowX: 'auto',
      '@media (min-width: 768px)': {
        overflow: 'visible'
      }
    },
    '& button': {
      padding: '8px 16px',
      borderRadius: '8px',
      background: '#292929',
      width: '106px',
      height: '38px',
      flexShrink: '0',
      textAlign: 'center',
      color: '#fff',
      '&:hover': {
        background: '#383838'
      },
      '&:focus': {
        outline: '1px solid #fff',
        outlineOffset: '2px'
      }
    }
  },
  yearBone: {
    background: '#f0f0f0'
  },
  activeYearGroup: {
    background: 'var(--yellow) !important',
    color: 'var(--gray) !important',
    fontWeight: 'bold !important'
  },
  presentations: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill,minmax(300px,1fr))',
    gap: '24px',
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '32px 0 24px'
  },
  highlight: {
    maxWidth: '560px',
    margin: '0 auto',
    padding: '48px 0 0',
    '& $presentation': {
      width: '100%',
      display: 'block'
    }
  },
  presentation: {
    paddingBottom: '56.2%',
    background: '#242424',
    borderRadius: '8px',
    overflow: 'hidden',
    position: 'relative',
    '& *': {
      pointerEvents: 'none'
    },
    '&:focus, &:active': {
      outline: '2px solid #fff',
      outlineOffset: '2px'
    }
  },
  presentationHolder: {
    position: 'absolute',
    left: '0',
    top: '0',
    width: '100%',
    height: '100%',
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    }
  },
  presentationTitle: {
    font: 'var(--heading--)',
    background: 'linear-gradient(to top, rgba(0, 0, 0, .8), rgba(0, 0, 0, 0))',
    color: '#fff',
    textAlign: 'center',
    padding: '120px 12px 12px',
    position: 'absolute',
    bottom: '0',
    left: '0',
    width: '100%',
    opacity: '0',
    animation: 'appear .3s forwards',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& span:first-child': {
      display: 'block',
      background: 'var(--yellow)',
      padding: '4px 8px',
      borderRadius: '4px',
      font: 'var(--body--)',
      fontWeight: 'bold',
      color: 'var(--gray)',
      margin: '0 0 8px',
      transform: 'translateY(-4px)',
      opacity: '0',
      animation: 'appear .6s ease-out forwards'
    }
  },
  spinner: {
    fontSize: '20px',
    color: 'var(--yellow)',
    margin: '0 0 8px'
  },
  free: {
    outline: '2px solid #fff',
    outlineOffset: '4px',
    position: 'relative',
    '&:after': {
      content: '"Free"',
      position: 'absolute',
      right: '8px',
      top: '8px',
      color: 'var(--gray)',
      background: '#fff',
      font: 'var(--body-)',
      fontWeight: 'bold',
      padding: '4px 16px',
      borderRadius: '4px'
    }
  },
  crown: {
    position: 'absolute',
    right: '8px',
    top: '8px',
    width: '24px',
    height: '24px',
    borderRadius: '24px',
    fontSize: '10px',
    background: 'rgba(0, 0, 0, .3)',
    color: 'var(--yellow)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  '@keyframes appear': {
    to: {
      transform: 'translateY(0)',
      opacity: '1'
    }
  }
})(({ classes }) => {
  const [presentations, setPresentations] = useState(null)
  const [yearGroups, setYearGroups] = useState(null)
  const [pending, setPending] = useState(false)

  const { hasAccessToTL } = useSubscriptionDetails()

  const presentationsMappedToKeywords = useMemo(
    () => {
      if (!presentations) return null
      return keywords.map(keyword => {
        return {
          keyword,
          presentation: presentations.find(
            presentation =>
              presentation.title.toLowerCase().indexOf(keyword) !== -1
          )
        }
      })
    },
    [presentations]
  )

  const presentationsList = useMemo(
    () => {
      if (!presentationsMappedToKeywords) return null
      return hasAccessToTL
        ? presentationsMappedToKeywords
        : presentationsMappedToKeywords.slice(
            1,
            presentationsMappedToKeywords.length - 1
          )
    },
    [hasAccessToTL, presentationsMappedToKeywords]
  )

  const firstPresentation =
    presentationsMappedToKeywords &&
    presentationsMappedToKeywords[0].presentation

  const match = useRouteMatch()

  const selectedYearGroup = match.params.year

  const history = useHistory()

  /**
   * Fetch yearGroups
   */
  useEffect(
    () => {
      apiClient
        .get('v3/year_groups', {
          params: {
            include: 'include=year_group.names,year_group.order'
          }
        })
        .then(res => {
          // We only need a limited amount of year groups from Age 5 to age 11
          const yearGroups = res.data.year_groups.slice(3, 9)
          setYearGroups(yearGroups)
        })
    },
    [] //eslint-disable-line
  )

  /**
   * Fetch presentations for selected year group
   */
  useEffect(
    () => {
      if (selectedYearGroup) {
        setPending(true)
        apiClient
          .get('v3/presentations/search', {
            params: {
              categories: ['theme_based'],
              from: 0,
              limit: 40,
              year_group_ids: [selectedYearGroup]
            }
          })
          .then(res => {
            setPresentations(res.data.presentations)
            setPending(false)
          })
          .catch(errorHandler)
      }
    },
    [selectedYearGroup]
  )

  const memoizedTopicsJSX = useMemo(
    () => {
      return (
        <>
          {!hasAccessToTL && (
            <div className={classes.highlight}>
              {!firstPresentation && <div className={classes.presentation} />}
              {firstPresentation && (
                <ButtonElement
                  onClick={() => {
                    window.scrollTo({ top: 0 })
                    history.push(`/prompt/${firstPresentation.id}`)
                  }}
                  className={`${classes.presentation} ${classes.free}`}>
                  <span className={classes.presentationHolder}>
                    <Image
                      loading="lazy"
                      src={firstPresentation.image_medium_url}
                      alt={firstPresentation.title}
                    />
                    <span className={classes.presentationTitle}>
                      {pending && <Spinner className={classes.spinner} />}
                      {!pending && (
                        <span key={firstPresentation.id}>
                          Age {firstPresentation.year_group_range.from}-{
                            firstPresentation.year_group_range.to
                          }
                        </span>
                      )}
                      <span>{firstPresentation.title}</span>
                    </span>
                  </span>
                </ButtonElement>
              )}
            </div>
          )}
          <div className={classes.presentations}>
            {!presentationsList &&
              [...new Array(30)].map((_, i) => (
                <div key={i} className={classes.presentation} />
              ))}
            {!!presentationsList &&
              presentationsList.map(({ keyword, presentation }, i) => {
                return !presentation ? (
                  <div key={i} className={classes.presentation} />
                ) : (
                  <ButtonElement
                    key={keyword}
                    onClick={() => {
                      window.scrollTo({ top: 0 })
                      history.push(`/prompt/${presentation.id}`)
                    }}
                    className={`${classes.presentation} ${
                      !hasAccessToTL ? 'metrics__restricted--topics' : ''
                    }`}>
                    <span className={classes.presentationHolder}>
                      <Image
                        loading="lazy"
                        src={presentation.image_medium_url}
                        alt={presentation.title}
                      />
                      <span className={classes.presentationTitle}>
                        {pending && <Spinner className={classes.spinner} />}
                        {!pending && (
                          <>
                            <span key={presentation.id}>
                              Age {presentation.year_group_range.from}-{
                                presentation.year_group_range.to
                              }
                            </span>
                          </>
                        )}
                        <span>{presentation.title}</span>
                      </span>
                      {!hasAccessToTL && (
                        <span className={classes.crown}>
                          <FontAwesomeIcon icon={faCrown} />
                        </span>
                      )}
                    </span>
                  </ButtonElement>
                )
              })}
          </div>
        </>
      )
    },
    [
      classes,
      firstPresentation,
      presentationsList,
      hasAccessToTL,
      history,
      pending
    ]
  )

  return (
    <PromptsLayout>
      <div className={classes.container}>
        <div className={classes.topBox}>
          <div>
            <p>
              Explore our differentiated topic lessons! Select your age group
              below.
            </p>
          </div>
          <div className={classes.yearGroupSelection}>
            <ul>
              {!yearGroups &&
                [...new Array(6)].map((_, i) => (
                  <ButtonElement key={i} className={classes.yearBone} />
                ))}
              {!!yearGroups &&
                yearGroups.map(yg => {
                  return (
                    <ButtonElement
                      key={yg.id}
                      onClick={() => history.push(`/prompt/topics/${yg.id}`)}
                      className={
                        yg.id === parseInt(selectedYearGroup)
                          ? classes.activeYearGroup
                          : null
                      }>
                      Age {yg.from}-{yg.to}
                    </ButtonElement>
                  )
                })}
            </ul>
          </div>
        </div>
        <main className={classes.main}>{memoizedTopicsJSX}</main>
      </div>
    </PromptsLayout>
  )
})
